/* KOKO TCG — fluidité (03/11/2026). Fichier KOKO, hors cœur de Concept. Chargé (defer) sur toutes les pages par intro_koko.
   Deux services pour les blocs faits main, sans aucun travail par image :
   1. .kk-pulse : pose --kk-h (hauteur du bouton, sans unité) pour les anneaux de pulsation de kk-fluide.css.
   2. img[data-kk-ombre] : « cuit » une fois les ombres portées CSS (filter: drop-shadow…) dans un canvas, et pose le
      résultat (les ombres seules) dans une <img class="kk-ombre"> juste derrière l'image, qui perd son filtre : l'image
      elle-même est rendue exactement comme avant, et un filtre sur une image qui bouge (la carte du parcours, l'avion)
      n'est plus recalculé par le GPU à chaque image. Mêmes gaussiennes (canvas shadowBlur = rayon de flou CSS,
      écart-type : pour drop-shadow() le rayon EST l'écart-type, pour le canvas c'est la moitié, d'où shadowBlur = 2 × rayon,
      vérifié au pixel sur Chromium le 03/11/2026), dessinées à la résolution de l'écran ; brightness()/contrast() qui
      suivent le drop-shadow restent sur l'image (bon marché) et sont appliqués aux ombres cuites. L'image doit être
      lisible par le canvas : même origine ou crossorigin="anonymous" (le CDN Shopify répond
      access-control-allow-origin: *). En cas d'échec (image tierce sans CORS, vieux navigateur), le filtre CSS reste. */
(function(){
  'use strict';

  /* ---------- 1. anneaux : hauteur du bouton ---------- */
  function anneaux(){
    var ws=[].slice.call(document.querySelectorAll('.kk-pulse'));
    if(!ws.length)return;
    function pose(w,h){if(h>0)w.style.setProperty('--kk-h',(Math.round(h*100)/100)+'');}
    if('ResizeObserver' in window){
      var ro=new ResizeObserver(function(es){es.forEach(function(e){pose(e.target,e.contentRect.height);});});
      ws.forEach(function(w){ro.observe(w);});
    }else{
      var mesure=function(){ws.forEach(function(w){pose(w,w.offsetHeight);});};
      mesure();window.addEventListener('resize',mesure,{passive:true});window.addEventListener('load',mesure);
    }
  }

  /* ---------- 2. ombres cuites ---------- */
  function lireFiltre(txt){
    /* « drop-shadow(rgba(255, 140, 42, 0.75) 0px 0px 18px) brightness(0.96) » → liste d'opérations */
    var ops=[],i=0,n=txt.length;
    while(i<n){
      while(i<n&&txt[i]===' ')i++;
      var j=txt.indexOf('(',i);if(j<0)break;
      var nom=txt.slice(i,j).trim(),depth=1,k=j+1;
      while(k<n&&depth){if(txt[k]==='(')depth++;else if(txt[k]===')')depth--;k++;}
      var args=txt.slice(j+1,k-1).trim();
      if(nom==='drop-shadow'){
        /* longueurs = nombres suivis de px (la valeur calculée a toujours l'unité) ; couleur = ce qui reste */
        var v=(args.match(/-?\d*\.?\d+(?=px)/g)||[]).map(parseFloat),reste=args.replace(/-?\d*\.?\d+px/g,' '),
            m=reste.match(/(rgba?\([^)]*\)|hsla?\([^)]*\)|color\([^)]*\)|#[0-9a-fA-F]{3,8}|[a-zA-Z]+)/),couleur=m?m[1]:'rgba(0,0,0,1)';
        if(v.length<2)return null;
        ops.push({type:'ombre',x:v[0],y:v[1],flou:v[2]||0,couleur:couleur});
      }else ops.push({type:'autre',css:nom+'('+args+')'});
      i=k;
    }
    return ops.length?ops:null;
  }

  /* Ombre « seule » d'une source dessinée hors du canvas : seule son ombre, décalée en retour, tombe dans le canvas. */
  function ombreSeule(W,H,source,dx,dy,sw,sh,op,dpr){
    var c=document.createElement('canvas');c.width=W;c.height=H;var ctx=c.getContext('2d'),OFF=W+1000;
    ctx.imageSmoothingEnabled=true;ctx.imageSmoothingQuality='high';
    ctx.shadowColor=op.couleur;ctx.shadowBlur=2*op.flou*dpr;ctx.shadowOffsetX=op.x*dpr+OFF;ctx.shadowOffsetY=op.y*dpr;
    ctx.drawImage(source,dx-OFF,dy,sw,sh);
    return c;
  }
  function cuire(img,filtre,done){
    var parent=img.parentNode,ops=lireFiltre(filtre);
    if(!ops||!img.naturalWidth){done(false);return;}
    var w=parent.clientWidth;if(!(w>0)){done(false);return;}
    var h=w*img.naturalHeight/img.naturalWidth,dpr=Math.min(2,window.devicePixelRatio||1); /* une ombre n'a que des dégradés doux : 2 px par point CSS suffisent, et la mémoire est divisée par deux sur un écran 3× */
    var ombres=ops.filter(function(o){return o.type==='ombre';}),autres=ops.filter(function(o){return o.type!=='ombre';});
    if(!ombres.length){done(false);return;}
    var marge=2;ombres.forEach(function(o){marge+=Math.max(Math.abs(o.x),Math.abs(o.y))+3.2*o.flou;});marge=Math.ceil(marge);
    var W=Math.round((w+2*marge)*dpr),H=Math.round((h+2*marge)*dpr);
    if(W*H>6e6){done(false);return;}
    try{
      /* chaîne drop-shadow(A) drop-shadow(B) : B est l'ombre de (image + ombre A). On garde seulement les ombres (S1 au-dessus de S2) :
         l'image d'origine reste l'élément <img>, rendue exactement comme avant, posée par-dessus. */
      var dx=marge*dpr,dy=marge*dpr,sw=w*dpr,sh=h*dpr,couches=[],source=img,sx=dx,sy=dy,ssw=sw,ssh=sh;
      for(var i=0;i<ombres.length;i++){
        var S=ombreSeule(W,H,source,sx,sy,ssw,ssh,ombres[i],dpr);couches.push(S);
        if(i<ombres.length-1){ /* source suivante = ombre + image (comme le filtre) */
          var A=document.createElement('canvas');A.width=W;A.height=H;var actx=A.getContext('2d');
          actx.imageSmoothingEnabled=true;actx.imageSmoothingQuality='high';
          actx.drawImage(S,0,0);actx.drawImage(img,dx,dy,sw,sh);
          source=A;sx=0;sy=0;ssw=W;ssh=H;
        }
      }
      var fin=document.createElement('canvas');fin.width=W;fin.height=H;var fctx=fin.getContext('2d');
      var reste=autres.map(function(o){return o.css;}).join(' ');
      if(reste&&typeof fctx.filter==='string')fctx.filter=reste; /* brightness(), contrast()… du filtre d'origine, appliqués aussi aux ombres */
      for(var k=couches.length-1;k>=0;k--)fctx.drawImage(couches[k],0,0);
      fin.toBlob(function(blob){
        if(!blob){done(false);return;}
        var url=URL.createObjectURL(blob),pre=new Image();
        pre.onload=function(){
          var om=parent.querySelector(':scope > img.kk-ombre');
          if(!om){om=document.createElement('img');om.className='kk-ombre';om.alt='';om.setAttribute('aria-hidden','true');om.draggable=false;parent.insertBefore(om,img);parent.style.isolation='isolate';}
          var ancien=om.getAttribute('data-kk-url');
          om.src=url;om.setAttribute('data-kk-url',url);
          om.style.cssText='position:absolute;left:-'+marge+'px;top:-'+marge+'px;width:'+(w+2*marge)+'px;height:'+(h+2*marge)+'px;max-width:none;margin:0;filter:none;pointer-events:none;z-index:-1;';
          img.style.filter=reste||'none';
          /* même animation CSS que l'image (ex. la carte qui flotte) : on aligne les horloges */
          if(img.getAnimations){var a=img.getAnimations(),b=om.getAnimations();for(var q=0;q<a.length&&q<b.length;q++){try{b[q].startTime=a[q].startTime;}catch(e){}}}
          if(ancien)setTimeout(function(){URL.revokeObjectURL(ancien);},1000);
          done(true,w);
        };
        pre.onerror=function(){done(false);};
        pre.src=url;
      },'image/png');
    }catch(e){done(false);}
  }

  function ombres(){
    var imgs=[].slice.call(document.querySelectorAll('img[data-kk-ombre]'));
    if(!imgs.length)return;
    imgs.forEach(function(img){
      var filtre=getComputedStyle(img).filter;
      if(!filtre||filtre==='none')return;
      var largeur=0,encours=false,attente=false,timer=null;
      function go(){
        if(!img.complete||!img.naturalWidth){img.addEventListener('load',go,{once:true});return;}
        if(encours){attente=true;return;}
        encours=true;
        cuire(img,filtre,function(ok,w){encours=false;if(ok)largeur=w;if(attente){attente=false;go();}});
      }
      /* à chaque changement de largeur du conteneur (point de rupture, rotation), on recuit : l'ombre reste en px CSS */
      if('ResizeObserver' in window){
        new ResizeObserver(function(){clearTimeout(timer);timer=setTimeout(function(){if(img.parentNode.clientWidth!==largeur)go();},150);}).observe(img.parentNode);
      }else{go();window.addEventListener('resize',function(){clearTimeout(timer);timer=setTimeout(go,200);},{passive:true});}
    });
  }

  function init(){anneaux();ombres();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
